import Synchro98 from '@/generated/classes/Synchro98';
export default class Synchro98Extend extends Synchro98 {
  constructor() {
    super();
  }
}
